module.exports = __webpack_public_path__ + "static/media/eple_gul-min.1c78a1c2.png";